import { Check } from "lucide-react";
import { useSearchParams } from "react-router";

import {
  Command,
  CommandEmpty,
  CommandInput,
  CommandItem,
  CommandList,
} from "@/components/ui/command";
import { useGetSKUsForSKUSelectionQuery } from "@/data/queries";
import { cn } from "@/lib/utils";

export const SKUCommand = () => {
  const { data: skusData, isLoading } = useGetSKUsForSKUSelectionQuery();
  const [searchParams, setSearchParams] = useSearchParams();

  const handleSelect = (skuId: string) => {
    const tempParams = new URLSearchParams(searchParams);

    tempParams.delete("page");
    tempParams.set("templateId", skuId);

    setSearchParams(tempParams);
  };

  if (isLoading || !skusData) return null;

  return (
    <Command>
      <CommandInput placeholder="SKU ID" />
      <CommandList>
        <CommandEmpty>No results</CommandEmpty>
        {skusData.templates.map((sku) => (
          <CommandItem
            key={sku.id}
            value={String(sku.id)}
            onSelect={handleSelect}
          >
            {sku.id} - {sku.name}
            <Check
              className={cn(
                "ml-auto",
                searchParams.get("templateId") === String(sku.id)
                  ? "opacity-100"
                  : "opacity-0",
              )}
            />
          </CommandItem>
        ))}
      </CommandList>
    </Command>
  );
};
